//      

import RootNodeProvider from "./RootNodeProvider";

                                                        

export default class EventEmitter {
	emitEvent = (type           , detail     ) => {
		const event = new CustomEvent(type, {detail});
		window.dispatchEvent(event);
		const rootNode = RootNodeProvider.getUclRootNode();
		if (rootNode) rootNode.dispatchEvent(event);
	};
}
